import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import CloseIcon from 'core/assets/icons/comunity/close.svg';
import nextIcon from 'core/assets/icons/comunity/swiper_next.svg';
import { SwiperPreviewProps } from "./index.d";

const SwiperPreview = ({items, selectedIndex, onClose}: SwiperPreviewProps) => {
  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
      style={{ zIndex: 1000 }}
    >
      <div className="max-w-4xl w-full">
        <Swiper
          initialSlide={selectedIndex}
          className="w-full rounded-lg"
          modules={[Navigation]}
          onInit={(swiper: any) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          ref={swiperRef}
        >
          {items.map((item, idx) => (
            <SwiperSlide key={idx} className="h-full">
              <div className="h-screen p-4 flex justify-center items-center">
                <div className="relative table-cell max-w-full max-h-[90vh]">
                  <button
                    onClick={onClose}
                    className="absolute -top-10 left-0 text-white text-xl"
                    type="button"
                  >
                    <img src={CloseIcon} alt="Close" />
                  </button>
                  {item.type === 'video' ? (
                    <video src={item.src} controls className="rounded-lg" />
                  ) : (
                    <img
                      src={item.src}
                      alt="Full Preview"
                      className="rounded-lg max-h-[80vh]"
                    />
                  )}
                  <div
                    className="absolute -bottom-10 left-0 text-white text-[14px] font-medium w-full text-center"
                  >
                    {idx + 1}/{items.length}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          {/* Custom Navigation Buttons */}
          <div className="absolute top-1/2 left-2.5 z-10 transform -translate-y-1/2">
            <div ref={prevRef}>
              <img src={nextIcon} alt="Prev" className="rotate-180" />
            </div>
          </div>
          <div className="absolute top-1/2 right-2.5 z-10 transform -translate-y-1/2">
            <div ref={nextRef}>
              <img src={nextIcon} alt="Next" />
            </div>
          </div>
        </Swiper>
      </div>
    </div>
  );
}

export default SwiperPreview
